export const User = {
  methods: {
    closeNumber() {
      this.checkNumber = false;
      this.successMessage = "Амжилттай хадгаллаа ";
      this.successModal = true;
    },
    successEdit() {
      this.successMessage = "Амжилттай хадгаллаа ";
      this.successModal = true;
    },
    hideSuccessMessage() {
      (this.successMessage = ""), (this.successModal = false);
    },
    // hide error message
    hideErrorMessage() {
      (this.errorMessage = ""), (this.errorModal = false);
    },
    change() {
      this.getDistrict(this.city);
    },
    idNumber() {
      this.checkNumber = !this.checkNumber;
    }
  }
};
